define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/Configuration',
	'internal_util/LocalizationUtil',
	'model/Image',
	'view/MainView',
	'view/ErrorView',
	'canvas/LogoCanvas',
	'lib/jquery',
	'lib/bootstrap/modal' // doesn't export
], function (
	Logger,
	Util,
	UiUtil,
	Configuration,
	LocalizationUtil,
	Image,
	MainView,
	ErrorView,
	LogoCanvas,
	jQuery
) {
	'use strict';

	function ModalView() {
		var _view;

		_view = (function () {
			var locales = LocalizationUtil.getAvailableLocalizations(),
				i,
				$view = jQuery(
					"<div id='skIdS_modal' class='modal fade' tabindex='-1' role='dialog' aria-labelledby='skIdS_modal-label' " +
							"aria-hidden='true'>" +
						"<div class='modal-dialog'>" +
							"<div class='modal-content'>" +
								"<div id='skIdS_modal-header' class='modal-header'>" +
									"<h4 id='skIdS_modal-label' class='modal-title'>&nbsp;</h4>" +
									"<div id='skIdS_modal-poweredByLogo' class='skIdS_providerinfo-poweredByLogo'>&nbsp;</div>" +
									"<span id='skIdS_locales'></span>" +
								"</div>" +
								"<div id='skIdS_modal-body' class='modal-body' />" +
								"<div id='skIdS_modal-footer' class='modal-footer'></div>" +
							"</div>" +
						"</div>" +
					"</div>"),
				$localeButton;


			for (i = 0; i < locales.length; i++) {
				if (i > 0) {
					$view.find('#skIdS_locales').append("<span class='skIdS_locale-delimiter'>|</span>");
				}

				$localeButton = jQuery("<span class='skIdS_locale-button'>" + locales[i].toUpperCase() + "</span>")
						.on('click', (function (locale) {
							return function () {
								LocalizationUtil.setLocale(locale);
							}
						})(locales[i]));

				$view.find('#skIdS_locales').append($localeButton);
			}

			UiUtil.setScrollContainer($view.find('#skIdS_modal-body'));

			return $view;
		})();

		MainView.call(this);


		// public methods

		this.get = function () {
			_view.modal({backdrop : false, show : false});

			return _view;
		};

		this.setTitle = function (title) {
			if (Util.isValidString(title)) {
				_view.find('#skIdS_modal-label').text(title);
			} else {
				_view.find('#skIdS_modal-label').html('&nbsp;');
			}
		};
		
		this.setPoweredByLogo = function(image) {
			if (image instanceof Image) {
				_view.find('#skIdS_modal-poweredByLogo').html('<img src="' + image.url() + '" width="' + image.width() + '" height="' + image.height() + '" />');
			} else {
				_view.find('#skIdS_modal-poweredByLogo').html('&nbsp;');
			}
		};

		this.setControls = function (controls) {
			var $footer = _view.find('#skIdS_modal-footer');

			$footer.children().detach();
			$footer.append(controls);
		};

		this.clearBody = function () {
			_view.find('#skIdS_modal-body').children().detach();
		};

		this.appendToBody = function (content) {
			_view.find('#skIdS_modal-body').append(content);
		};

		this.show = function (animate, callbacks) {
			if (typeof animate !== 'undefined' && !animate) {
				_view.removeClass('fade');
			}

			if (typeof callbacks !== 'undefined') {
				_view.one('shown.bs.modal', function (event) {
					if (event.target === _view.get(0)) {
						Util.callCallbacks(callbacks);
					}
				});
			}

			_view.modal('show');
		};

		this.hide = function (animate, callbacks) {
			if (typeof animate !== 'undefined' && !animate) {
				_view.removeClass('fade');
			}

			if (typeof callbacks !== 'undefined') {
				_view.one('hidden.bs.modal', function (event) {
					if (event.target === _view.get(0)) {
						Util.callCallbacks(callbacks);
					}
				});
			}

			_view.modal('hide');
		};
	}

	ModalView.prototype = Object.create(MainView.prototype);

	return ModalView;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/mainview/ModalView.js
// module id = 368
// module chunks = 1